import React, { useReducer } from 'react';
import LocationContext from '../context/location-context';
import PostContext from '../context/post-context';
import postReducer, { DEFAULT_POST_REDUCER } from '../reducers/post';
import locationReducer, {
  DEFAULT_LOCATION_REDUCER
} from '../reducers/location';
import MapPanel from '../components/MapPanel/MapPanel';
// import PostsPanel from '../components/PostsPanel';

const RakNRollApp = props => {
  const [locations, dispatchLocations] = useReducer(
    locationReducer,
    DEFAULT_LOCATION_REDUCER
  );
  // const [gps, dispatchGps] = useReducer(locationReducer, DEFAULT_LOCATION_REDUCER);
  const [posts, dispatchPosts] = useReducer(postReducer, DEFAULT_POST_REDUCER);

  return (
    <>
      <LocationContext.Provider value={{ locations, dispatchLocations }}>
        <PostContext.Provider value={{ posts, dispatchPosts }}>
          <MapPanel></MapPanel>
        </PostContext.Provider>
      </LocationContext.Provider>
      {/*
          <MapPanel></MapPanel>
          <PostsPanel></PostsPanel>
         */}
    </>
  );
};

export { RakNRollApp as default };
